var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InputComponent',{attrs:{"icon":['fal', 'search'],"icon-placement":"right","label":_vm.$t('search'),"placeholder":_vm.placeholder,"value":_vm.value,"type":"search"},on:{"input":$ev => _vm.$emit('input', $ev)}})
}
var staticRenderFns = []

export { render, staticRenderFns }